/** @jsx jsx */
import React from 'react'
import { jsx } from '@emotion/react'

import HR from '../components/misc/HR'
import AboutUsSection1 from '../components/aboutUs/AboutUsSection1'
import AboutUsSection2 from '../components/aboutUs/AboutUsSection2'
import AboutUsSection3 from '../components/aboutUs/AboutUsSection3'
import AboutUsSection4 from '../components/aboutUs/AboutUsSection4'
import AboutUsSection5 from '../components/aboutUs/AboutUsSection5'
import AboutUsSection6 from '../components/aboutUs/AboutUsSection6'
import AboutUsSection7 from '../components/aboutUs/AboutUsSection7'
import PublicViewsHeader from '../components/headers/PublicViewsHeader'
import PublicViewsFooter from '../components/footers/PublicViewsFooter'
import useStaticImage from '../components/hooks/useStaticImage'
import { imagekitUrl } from '../utils/imagekit'
import TrackPageview from '../components/tracking/TrackPageview'

const HomeView = () => {
  const { staticImage: img1 } = useStaticImage('about-main-banner')
  const { staticImage: img2 } = useStaticImage('about-computer')
  const { staticImage: img3 } = useStaticImage('about-discover-gif')
  const { staticImage: img4 } = useStaticImage('about-collage')
  const { staticImage: img5 } = useStaticImage('about-shelf')

  if (!img1 || !img2 || !img3 || !img4 || !img5) {
    return null
  }

  const image1 = imagekitUrl(img1.image || '', '?tr=w-1920')
  const image2 = imagekitUrl(img2.image || '', '?tr=w-937')
  const image3 = imagekitUrl(img3.image || '', '?tr=w-908')
  const image4 = imagekitUrl(img4.image || '', '?tr=w-1377')
  const image5 = imagekitUrl(img5.image || '', '?tr=w-1111')

  return (
    <React.Fragment>
      <TrackPageview />
      <div css={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <div css={{ flex: '0 0 auto' }}>
          <PublicViewsHeader />
        </div>
        <div css={{ flex: '1 1 auto', position: 'relative' }}>
          <AboutUsSection1 img={image1} />
        </div>
      </div>
      <AboutUsSection2 img={image2} />
      <div css={{ maxWidth: '90%', marginLeft: 'auto', marginRight: 'auto' }}>
        <HR />
      </div>
      <AboutUsSection3 />
      <AboutUsSection4 img={image3} />
      <AboutUsSection5 img={image4} />
      <AboutUsSection6 />
      <AboutUsSection7 img={image5} />
      <PublicViewsFooter />
    </React.Fragment>
  )
}

export default HomeView
